import { Outlet } from 'react-router-dom';

export default function RoutingLayout() {
    return (
        <Outlet />
    );
}
